<template>

    <input
        :disabled="disabled"
        :placeholder="placeholder"
        type="text"
        :class="[disabled ? 'is-disabled' : '', 'h-4', 'fs-3']"
        class="h-4"
        v-model="currentValue"
        @keydown="onKeydown"
        @blur="validate"/>

</template>

<script>
    const KEY_DOWN = 40
    const KEY_UP = 38

    export default {
        props: {
            value: {
                type: Number,
                required: false,
                default : 0
            },
            max: {
                type: Number,
                required: false
            },
            min: {
                type: Number,
                required: false
            },
            step: {
                type: Number,
                required: false,
                default : 1
            },
            precision: {
                type: Number,
                required: false,
                default : 0
            },
            separatorDecimal: {
                type: String,
                required: false,
                default : '.',
                validator: function (value) {
                    return ['.', ','].indexOf(value) !== -1
                }
            },
            separatorThousand: {
                type: String,
                required: false,
                validator: function (value) {
                    return ['.', ',', ' '].indexOf(value) !== -1
                }
            },
            disabled:{
                type: Boolean,
                required: false,
                default : false
            },
            placeholder:{
                type: String,
                required: false
            },
            emptyAtStart:{
                type: Boolean,
                required: false,
                default : false
            }
        },
        data () {
            return {
                currentValue: this.value,
                numberValue: this.value,
                previousValue: this.value,
                cleared: this.emptyAtStart
            }
        },
        mounted: function () {
            if (this.separatorThousand == this.separatorDecimal) {
                throw new TypeError("separator-thousand and separator-decimal can't have the same value")
            }
            this.validate()
        },
        methods: {
            validate () {
                if (this.cleared) {
                    this.currentValue = ""
                    this.cleared = false
                    return
                }
                this.removeSeparatorThousand()
                this.removeSeparatorDecimal()

                this.numberValue = parseFloat(this.currentValue)

                if (isNaN(this.numberValue)) {
                    this.numberValue = this.previousValue
                }

                this.cap()

                this.numberValue = parseFloat(this.numberValue.toFixed(this.precision))

                this.previousValue = this.numberValue
                this.$emit('input', this.numberValue)

                //Display format
                this.applySeparatorDecimal()
                this.applySeparatorThousand()
            },
            removeSeparatorDecimal(){
                if (this.separatorDecimal != '.') {
                    this.currentValue = this.currentValue.toString().replace(this.separatorDecimal, ".")
                }
            },
            applySeparatorDecimal(){
                this.currentValue = this.numberValue.toString()

                if (this.separatorDecimal != '.') {
                    this.currentValue = this.currentValue.replace(".", this.separatorDecimal)
                }
            },
            removeSeparatorThousand(){
                if (this.separatorThousand != undefined) {
                    this.currentValue = this.currentValue.toString().replace(this.separatorThousand, '');
                }
            },
            applySeparatorThousand(){
                if (this.separatorThousand != undefined) {
                    this.currentValue = this.currentValue.replace(/\B(?=(\d{3})+(?!\d))/g, this.separatorThousand);
                }
            },
            cap(){
                if (this.max != undefined && this.numberValue > this.max) {
                    this.numberValue = this.max
                }

                if (this.min != undefined && this.numberValue < this.min) {
                    this.numberValue = this.min
                }
            },
            onKeydown (e) {
                let fired = false
                if (e.keyCode === KEY_DOWN) {
                    this.decrement()
                    fired = true
                }
                if (e.keyCode === KEY_UP) {
                    this.increment()
                    fired = true
                }
                if (fired) {
                    this.cap()
                    this.$emit('input', this.numberValue)
                    this.applySeparatorDecimal()
                    this.applySeparatorThousand()
                }
            },
            decrement () {
                this.numberValue -= this.step
            },
            increment () {
                this.numberValue += this.step
            }
        }
    }
</script>
<style scoped>
    input.is-disabled {
        background-color: #f5f7fa;
        border-color: #e4e7ed;
        color: #c0c4cc;
        cursor: not-allowed;
    }
    input.is-disabled::placeholder {
        color: #c0c4cc;
    }
</style>
